import { createAction } from 'redux-actions';

export const clearSideBySideElementsMap = createAction(
  'CLEAR_SIDE_BY_SIDE_ELEMENTS_MAP',
);
export const setTargetStatementBatchElementsMapAction = createAction(
  'SET_TARGET_STATEMENT_BATCH_ELEMENTS_MAP_ACTION',
);
export const setSourceStatementBatchElementsMapAction = createAction(
  'SET_SOURCE_STATEMENT_BATCH_ELEMENTS_MAP_ACTION',
);

//OCR actions
export const clearLeftOCRSectionImageWithIdsFromCache = createAction(
  'CLEAR_LEFT_OCR_IMAGE_WITH_IDS_FROM_CACHE',
);
export const clearLeftOCRSectionContentWithIdsFromCache = createAction(
  'CLEAR_LEFT_OCR_CONTENT_WITH_IDS_FROM_CACHE',
);
export const clearOCRSectionContentWithIdsFromCache = createAction(
  'CLEAR_OCR_CONTENT_WITH_IDS_FROM_CACHE',
);
export const clearOCRSectionImageWithIdsFromCache = createAction(
  'CLEAR_OCR_IMAGE_WITH_IDS_FROM_CACHE',
);
export const clearElementWithIdsFromCache = createAction(
  'CLEAR_ELEMENT_WITH_IDS_FROM_CACHE',
);

//Legacy actions
export const clearSectionContentWithIdsFromCache = createAction(
  'CLEAR_CONTENT_WITH_IDS_FROM_CACHE',
);
export const replaceSelectedElementsContentPanel = createAction(
  'REPLACE_SELECTED_ELEMENTS_CONTENT_PANEL',
);
export const replaceSelectedElementWithoutRemovingOld = createAction(
  'REPLACE_SELECTED_ELEMENTS_WITHOUT_REMOVING_OLD',
);
export const clearSelectedElementsContentPanel = createAction(
  'CLEAR_SELECTED_ELEMENTS_CONTENT_PANEL',
);
export const selectElementContentPanel = createAction(
  'SELECT_ELEMENT_CONTENT_PANEL',
);
export const deselectElementContentPanel = createAction(
  'DESELECT_ELEMENT_CONTENT_PANEL',
);
export const setProjectSocketDisconnectAction = createAction(
  'SET_PROJECT_SOCKET_DISCONNECT_ACTION',
);
export const setSocketDisconnectAction = createAction(
  'SET_SOCKET_DISCONNECT_ACTION',
);
export const setGlobalSocketDisconnectAction = createAction(
  'SET_GLOBAL_SOCKET_DISCONNECT_ACTION',
);
export const setProjectIdWorkflowExpanded = createAction(
  'SET_PROJECT_FOR_WORKFLOWS_EXPANDED',
);
export const clearBatchSelectedElementsAction = createAction(
  'BATCH_CLEAR_SELECTED_ELEMENTS',
);
export const selectMultipleElementsContentPanel = createAction(
  'SELECT_MULTIPLE_ELEMENTS_CONTENT_PANEL',
);
export const resetToPreviousSelectedElementMap = createAction(
  'RESET_TO_PREVIOUS_SELECTED_ELEMENT_MAP',
);
export const clearingElementMapSuccessAction = createAction(
  'CLEARING_ELEMENT_MAP_SUCCESS_ACTION',
);